import React, { Component } from "react";
import "./Collection.css";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import data from "../../data/data";
import SingleCollection from "../../components/SingleCollection";

class Collection extends Component {
  render() {
    const activeCollection =
      this.props.location.state !== undefined
        ? this.props.location.state.page
        : 0;
    return (
      <div className="Collection">
        <SingleCollection
          data={data.singleCollection}
          activeCollection={activeCollection}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    language: state.language
  };
}

export default withRouter(connect(mapStateToProps)(Collection));



// WEBPACK FOOTER //
// ./src/views/Collection/index.js